<div class="note">
  <div>
    @if (!note.updatedBy) {
      <span class="note__name" [ngClass]="{'note__name-error': note.error && note.isEditMode }">
        {{note.createdBy}}
      </span>
    }
    @if (note.updatedBy) {
      <span class="note__name" [ngClass]="{'note__name-error': note.error && note.isEditMode }">
        {{note.updatedBy}}
      </span>
    }
    @if (!note.isNewNote) {
      <span class="note__date"> - {{note.updatedAt | locTimeZoneDate:'MMM DD, YYYY hh:mm A'}}</span>
    }
  </div>
  @if (!note.isEditMode && !note.isNewNote) {
    <div>
      <div class="note__text">{{note.note}}</div>
      @if (!disableChanges) {
        <div fxLayout="row" fxLayoutAlign="start center">
          @if (!readOnly) {
            <button type="button" class="note__edit-button cfa-plain-button cfa-plain-button--inline" data-testid="edit-note-button" (click)="editNote()">Edit Note</button>
          }
          @if (deleteEnabled) {
            <button type="button" class="note__delete-button cfa-plain-button cfa-plain-button--inline" data-testid="delete-note-button" (click)="deleteNote()">Delete Note</button>
          }
        </div>
      }
    </div>
  }
  @if (note.isEditMode || note.isNewNote) {
    <div class="note__edit-container" fxLayout="column" fxLayoutAlign="space-around start">
      @if (subText) {
        <mat-hint class="note__sub-text" align="left">{{subText}}</mat-hint>
      }
      <div class="note__full-width-container">
        <mat-form-field class="note__full-width-container" floatLabel="never">
          <mat-placeholder class="note__placeholder">Add a note</mat-placeholder>
          <textarea #textInput
            matInput
            cdkTextareaAutosize
            maxlength="500"
            rows="5"
            class="note__text-area"
            data-testid="note-text-area"
            [ngClass]="{'note__text-area-error': note.error}"
            [ngModel]="note.updatedText"
            (keyup)="updateText($event)">
          </textarea>
          <mat-hint class="note__disclaimer" align="left">
            *Do not enter sensitive guest details such as credit card numbers, emails, etc.
          </mat-hint>
          <mat-hint class="note__character-count" align="end">{{note.updatedText.length}} / 500</mat-hint>
        </mat-form-field>
      </div>
      @if (note.error) {
        <div fxLayout="row" fxLayoutAlign="start center">
          <mat-icon class="note__error-icon">warning</mat-icon>
          <div class="note__error-text">We were unable to save your note. Please try again later.</div>
        </div>
      }
      <div fxLayout="row"
        fxLayoutAlign="end center"
        class="note__full-width-container">
        <button mat-button
          class="note__cancel-button"
          data-testid="cancel-button"
          (click)="cancelEdit()">
          Cancel
        </button>
        <button mat-raised-button
          class="note__save-button"
          [disabled]="note.updatedText.trim().length < 1"
          data-testid="save-button"
          (click)="saveNote()">
          Save
        </button>
      </div>
    </div>
  }
</div>
